<template>
  <TabbedBox :useQueryNavigation="true">
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-invoicevalue-glass">
        <i class="far fa-layer-group"></i> Glass
      </Tab>
      <Tab tabid="tab-invoicevalue-glassService">
        <i class="far fa-tools"></i> Glass Service
      </Tab>
      <Tab tabid="tab-invoicevalue-other">
        <i class="far fa-inventory"></i> Other
      </Tab>
      <Tab tabid="tab-invoicevalue-stocktype">
        <i class="far fa-clipboard-list-check"></i> Stock Type
      </Tab>
      <Tab tabid="tab-invoicevalue-pricegroup">
        <i class="far fa-money-check-edit-alt"></i> Price Group
      </Tab>
      <Tab tabid="tab-invoicevalue-squaremeterage">
        <i class="far fa-ruler"></i> Square Meterage
      </Tab>
      <Tab tabid="tab-invoicevalue-contact">
        <i class="far fa-user"></i> Contact
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-invoicevalue-glass">
        <InvoiceValueSummaryList title="Glass Value" :startDate="startDate" :endDate="endDate" @applyFilter="applyFilter" @resetFilter="resetFilter" :valueList="glassValueList" :monthList="monthList" reportField="invoiceValueGlassList" />
      </TabPage>
      <TabPage tabid="tab-invoicevalue-glassService">
        <InvoiceValueSummaryList title="Glass Service Value" :startDate="startDate" :endDate="endDate" @applyFilter="applyFilter" @resetFilter="resetFilter" :valueList="glassServiceValueList" :monthList="monthList" reportField="invoiceValueServiceList" />
      </TabPage>
      <TabPage tabid="tab-invoicevalue-other">
        <InvoiceValueSummaryList title="Other Value" :startDate="startDate" :endDate="endDate" @applyFilter="applyFilter" @resetFilter="resetFilter" :valueList="otherValueList" :monthList="monthList" reportField="invoiceValueOtherList" />
      </TabPage>
      <TabPage tabid="tab-invoicevalue-stocktype">
        <InvoiceValueSummaryList title="Stock Type Value" :startDate="startDate" :endDate="endDate" @applyFilter="applyFilter" @resetFilter="resetFilter" :valueList="stockTypeValueList" :monthList="monthList" reportField="invoiceValueStockTypeList" />
      </TabPage>
      <TabPage tabid="tab-invoicevalue-pricegroup">
        <InvoiceValueSummaryList title="Price Group Value" :startDate="startDate" :endDate="endDate" @applyFilter="applyFilter" @resetFilter="resetFilter" :valueList="priceGroupValueList" :monthList="monthList" reportField="invoiceValuePriceGroupList" />
      </TabPage>
      <TabPage tabid="tab-invoicevalue-squaremeterage">
        <InvoiceValueSummaryList title="Stock Square Meterage" :startDate="startDate" :endDate="endDate" @applyFilter="applyFilter" @resetFilter="resetFilter" :valueList="stockSquareMeterageList" :monthList="monthList" reportField="invoiceMeterageStockList" />
      </TabPage>
      <TabPage tabid="tab-invoicevalue-contact">
        <InvoiceValueSummaryList title="Contact Value" :startDate="startDate" :endDate="endDate" @applyFilter="applyFilter" @resetFilter="resetFilter" :valueList="contactValueList" :monthList="monthList" reportField="invoiceValueContactList" />
      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

import Utils from '@/utils/utils'
import InvoiceValueSummaryList from '@/modules/intelligence/components/invoiceValueSummaryList'

export default {
  name: 'InvoiceValueGroups',
  components: {
    InvoiceValueSummaryList
  },
  data() {
    return {
      invoiceSummary: {},

      startDate: moment().local().startOf('year').startOf('day').toDate().toISOString(),
      endDate: moment().local().endOf('year').endOf('day').toDate().toISOString()
    }
  },
  computed: {
    monthList() {
      var maxMonthCount = 18      // No more than 1.5 years

      var monthCount = Math.abs(parseInt(Math.round(moment.duration(moment(this.endDate).diff(this.startDate)).asMonths())))
      monthCount = Math.min(monthCount, maxMonthCount)   

      var outputMonthList = []
      for(var monthIndex=0; monthIndex<monthCount; monthIndex++) {
        let monthStart = moment(this.startDate).local().startOf('month').add(monthIndex, 'months')
        let monthName = monthStart.format('MMM \'YY')

        outputMonthList.push({
          title: monthName,
          index: monthIndex,
          key: monthStart.toISOString(),
          monthStart: monthStart,
          monthEnd: monthStart.clone().endOf('month'),
          month: parseInt(monthStart.format('M')),
          year: parseInt(monthStart.format('YYYY'))
        })
      }

      return outputMonthList
    },
    glassValueList() {
      if(!this.invoiceSummary.invoiceValueGlassList)
        return []
      return this.invoiceSummary.invoiceValueGlassList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatCurrency(group.value),
          stockId: group.id,

          monthList: this.generateMonthList(group, this.formatCurrency)
        }
      })
    },
    glassServiceValueList() {
      if(!this.invoiceSummary.invoiceValueServiceList)
        return []
      return this.invoiceSummary.invoiceValueServiceList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatCurrency(group.value),
          stockId: group.id,

          monthList: this.generateMonthList(group, this.formatCurrency)
        }
      })
    },
    otherValueList() {
      if(!this.invoiceSummary.invoiceValueOtherList)
        return []
      return this.invoiceSummary.invoiceValueOtherList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatCurrency(group.value),
          stockId: group.id,

          monthList: this.generateMonthList(group, this.formatCurrency)
        }
      })
    },
    stockTypeValueList() {
      if(!this.invoiceSummary.invoiceValueStockTypeList)
        return []
      return this.invoiceSummary.invoiceValueStockTypeList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatCurrency(group.value),

          monthList: this.generateMonthList(group, this.formatCurrency)
        }
      })
    },
    priceGroupValueList() {
      if(!this.invoiceSummary.invoiceValuePriceGroupList)
        return []
      return this.invoiceSummary.invoiceValuePriceGroupList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatCurrency(group.value),

          monthList: this.generateMonthList(group, this.formatCurrency)
        }
      })
    },
    stockSquareMeterageList() {
      if(!this.invoiceSummary.invoiceMeterageStockList)
        return []
      return this.invoiceSummary.invoiceMeterageStockList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatDecimal(group.value, 2, true) + ' m&sup2;',
          stockId: group.id,

          monthList: this.generateMonthList(group, value => { return this.formatDecimal(value, 2, true) + ' m&sup2;' })
        }
      })
    },
    contactValueList() {
      if(!this.invoiceSummary.invoiceValueContactList)
        return []
      return this.invoiceSummary.invoiceValueContactList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatCurrency(group.value),
          contactId: group.id,

          monthList: this.generateMonthList(group, this.formatCurrency)
        }
      })
    }    
  },
  mounted() {
    this.requestSummary()

    this.subscribeEndpoint('/invoices', () => {
      this.requestSummary()
    })
  },
  beforeDestroy() {
    this.unsubscribeEndpoint('/invoices')
  },
  methods: {
    requestSummary() {

      var summaryFilter = {
        startDate: this.startDate,
        endDate: this.endDate,
        maxGroupSize: 0,
        includeMonthBreakdown: true
      }

      this.$apiService.analyticsService.getInvoicesValueFullSummary(summaryFilter)
      .then(response => {
        this.invoiceSummary = response.data
      })
    },
    applyFilter(data) {
      this.startDate = data.startDate
      this.endDate = data.endDate
      
      this.requestSummary()
    },
    resetFilter() {
      this.startDate = moment().local().startOf('month').startOf('day').toDate().toISOString()
      this.endDate = moment().local().endOf('month').endOf('day').toDate().toISOString()

      this.requestSummary()
    },
    generateMonthList(groupRow, formatter) {
      return this.monthList.map(monthInfo => {
        let monthValue = (groupRow.monthList || []).find(monthData => monthData.month == monthInfo.month && monthData.year == monthInfo.year)

        return {
          key: monthInfo.key,
          displayValue: monthValue ? formatter(monthValue.value) : '-'
        }
      })
    }
  }
}
</script>
